import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'

import { Card } from '../../../../../components'
import { getDetail, THEMES } from '../../../../../utils'

/**
 * Contact Detail Component
 * @param props
 * @returns {*}
 * @constructor
 */
const Contact = (props) => {
  const { directPhone, phoneExtension, mobile, email } = props

  return (
    <Card
      title='Personal Information'
      theme={THEMES.DARK_SLATE}>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <div className='card_section'>
            <div className='card_section-subtitle'>Primary Phone</div>
            <div className='card_section-detail'>{getDetail(directPhone)}</div>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div className='card_section'>
            <div className='card_section-subtitle'>Extension</div>
            <div className='card_section-detail'>{getDetail(phoneExtension)}</div>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div className='card_section'>
            <div className='card_section-subtitle'>Mobile Phone</div>
            <div className='card_section-detail'>{getDetail(mobile)}</div>
          </div>
        </Grid>
        <Grid item xs={6}>
          <div className='card_section'>
            <div className='card_section-subtitle'>Email Address</div>
            <div className='card_section-detail'>{getDetail(email)}</div>
          </div>
        </Grid>
      </Grid>
    </Card>
  )
}

Contact.propTypes = {
  directPhone: PropTypes.string,
  phoneExtension: PropTypes.string,
  mobile: PropTypes.string,
  email: PropTypes.string
}

export default Contact
